import React, { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify"
import { MONTHS, DEALER_TYPES, filterByType, fmt, usePlanFactData, savePlanItems, PfStyles } from "./common"

// Plan sahifasi — dilerlar uchun faqat oylik REJA o'rnatiladi
function Plan() {
	const { t } = useTranslation()

	const now = new Date()
	const [month, setMonth] = useState(now.getMonth() + 1)
	const [year, setYear] = useState(now.getFullYear())
	const [dealerType, setDealerType] = useState("all")
	const [saving, setSaving] = useState(false)

	const { rows, setRows, loading } = usePlanFactData(month, year)

	// Tanlangan diler turi bo'yicha ko'rinadigan qatorlar
	const shownRows = useMemo(() => filterByType(rows, dealerType), [rows, dealerType])

	const years = useMemo(() => {
		const y = new Date().getFullYear()
		return [y - 2, y - 1, y, y + 1]
	}, [])

	function onPlanChange(id, value) {
		const num = Number(String(value).replace(/\D/g, "")) || 0
		setRows((prev) => prev.map((r) => (r.id === id ? { ...r, plan: num } : r)))
	}

	async function save() {
		setSaving(true)
		try {
			// POST /services/admin/api/plan-fact
			const res = await savePlanItems(year, month, rows)
			if (!res || res.status !== 200) {
				toast.error(t("Xatolik yuz berdi"))
			}
		} catch (e) {
			toast.error(t("Xatolik yuz berdi"))
		} finally {
			setSaving(false)
		}
	}

	const totalPlan = useMemo(() => shownRows.reduce((s, r) => s + (Number(r.plan) || 0), 0), [shownRows])

	return (
		<div className="plan-fact">
			<div className="pf-header">
				<div>
					<h4 className="pf-title">{t("Plan")}</h4>
					<div className="pf-subtitle">{t("Dilerlar uchun oylik savdo rejasini o'rnating")}</div>
				</div>
				<div className="pf-controls">
					<select className="pf-select" value={dealerType} onChange={(e) => setDealerType(e.target.value)}>
						{DEALER_TYPES.map((d) => (
							<option key={d.value} value={d.value}>{t(d.i18n)}</option>
						))}
					</select>
					<select className="pf-select" value={month} onChange={(e) => setMonth(Number(e.target.value))}>
						{MONTHS.map((m, i) => (
							<option key={i} value={i + 1}>{t(m)}</option>
						))}
					</select>
					<select className="pf-select" value={year} onChange={(e) => setYear(Number(e.target.value))}>
						{years.map((y) => (
							<option key={y} value={y}>{y}</option>
						))}
					</select>
					<button className="pf-btn pf-btn-primary" onClick={save} disabled={saving || loading}>
						{saving ? t("Saqlanmoqda...") : t("Saqlash")}
					</button>
				</div>
			</div>

			<div className="pf-card cols-2">
				<div className="pf-row pf-row-head">
					<div className="pf-col-name">{t("Diler")}</div>
					<div className="pf-col-num">{t("Reja (so'm)")}</div>
				</div>

				{loading ? (
					<div className="pf-empty">{t("Yuklanmoqda...")}</div>
				) : shownRows.length === 0 ? (
					<div className="pf-empty">{t("LIST_IS_EMPTY")}</div>
				) : (
					shownRows.map((r, i) => (
						<div className="pf-row" key={r.id}>
							<div className="pf-col-name">
								<span className="pf-index">{i + 1}.</span> {r.name}
							</div>
							<div className="pf-col-num">
								<input
									type="text"
									className="pf-input"
									value={r.plan ? fmt(r.plan) : ""}
									placeholder="0"
									onChange={(e) => onPlanChange(r.id, e.target.value)}
								/>
							</div>
						</div>
					))
				)}

				{shownRows.length > 0 && (
					<div className="pf-row pf-row-total">
						<div className="pf-col-name">{t("Jami")}:</div>
						<div className="pf-col-num">{fmt(totalPlan)}</div>
					</div>
				)}
			</div>

			<div className="pf-note">
				{t("Bu yerda faqat reja o'rnatiladi. Haqiqiy bajarilish «Fakt» bo'limida ko'rinadi.")}
			</div>

			<PfStyles />
		</div>
	)
}

export default Plan
